<template>
  <pnet-validation-observer>
    <label>
      <small>{{label}}</small>
    </label>
    <div class="form-row" v-for="(stringValue, index) in stringList" v-bind:key="index">
      <div class="col-1" v-if="showLabel">
        <text-field
          v-model="stringList[index].valueLabel"
          :readonly="labelReadonly"
          v-if="!labelFix"
        ></text-field>
        <div v-if="labelFix">
          {{stringList[index].valueLabel}}
        </div>
      </div>
      <div class="col-1" v-if="showSign && onLeft">
        <text-field
          v-model="stringList[index].valueSign"
          :readonly="signReadonly"
        ></text-field>
      </div>      
      <div class="col-6">
        <text-field v-model="stringList[index].value"></text-field>
      </div>
      <div class="col-1" v-if="showSign && !onLeft">
        <text-field
          v-model="stringList[index].valueSign"
          :readonly="signReadonly"
        ></text-field>
      </div>
    </div>
    <div class="" v-if="!disableAdd">
      <div class="filtri mb-4">
        <div class="col-12 col-md-4 col-lg-12" align="left">
          Aggiungi&nbsp;&nbsp;<b-button class="btn btn-primary p-1 pl-3 pr-3" v-on:click.prevent="inserisci">+</b-button>
          <b-button
            v-if="stringList.length > 1"
            class="btn btn-primary p-1 pl-3 pr-3"
            v-on:click.prevent="cancella"
          >-</b-button>
        </div>
      </div>
    </div>
  </pnet-validation-observer>
</template>

<script lang="js">
import Vue from "vue";
import TextField from "@/components/TextField.vue";
export default Vue.extend({
  props: {
    value: Array,
    label: String,
    showSign: Boolean,
    signValue: String,
    signReadonly: Boolean,
    signOnLeft: Boolean,
    showLabel: Boolean,
    labelValue: String,
    labelReadonly: Boolean,
    labelFix: Boolean,
    disableAdd: Boolean,
    startingCounter: {
      type: Number,
      required: false,
      default: 1
    },
    descSorting: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    TextField,
  },
  data: function() {
    return {
      stringList: [{ value: "", valueSign: "", valueLabel: "" }],
      onLeft: false,
    }
  },
  methods: {
    inserisci: function() {
      if (!this.descSorting) {
        this.stringList.push({ value: "", valueSign: "", valueLabel: "" });
      } else {
        this.stringList.unshift({ value: "", valueSign: "", valueLabel: "" });
      }
    },
    cancella: function() {
      if (!this.descSorting) {
        this.stringList.pop();
      } else {
        this.stringList.shift();
      }
    },
    isEmptyOrSpaces: function(str) {
      return str === null || str.match(/^ *$/) !== null;
    },
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler() {
        if (this.value === undefined) {
          this.stringList = [{ value: "", valueSign: "", valueLabel: "" }];
        } else {
          this.stringList = this.value;
        }
        if (this.signValue !== undefined) {
          for (let i in this.value) {
            if ((this.value[i].valueSign === undefined || this.isEmptyOrSpaces(this.value[i].valueSign)) &&
                (this.value[i].value === undefined || this.isEmptyOrSpaces(this.value[i].value))) {
              this.value[i].valueSign = this.signValue;
            }
          }
        }
        if (this.labelValue !== undefined) {
          if (!this.descSorting) {
            let counter = this.startingCounter;
            for (let i in this.value) {
              this.value[i].valueLabel = this.labelValue.replace(/<index>/g, counter);
              counter++;
            }
          } else {
            let counter = this.startingCounter + this.value.length - 1;
            this.value[0].valueLabel = this.labelValue.replace(/<index>/g, counter);
          }
        }
      }
    },
    stringList: {
      deep: true,
      immediate: true,
      handler(){
        this.$emit('input', this.stringList);
      }
    },
    onLeft: {
      deep: true,
      immediate: true,
      handler(){
        this.onLeft = this.signOnLeft;
      }
    }
  },
  mounted() {
    this.stringList = this.value;
    if (this.signOnLeft !== undefined) {
      this.onLeft = this.signOnLeft;
    } else {
      this.onLeft = false;
    }
  },
});
</script>